import React, { useEffect } from 'react';
import { Modal, Form } from 'antd';
import ContactsFormSection from '../common/ContactsFormSection';
import type { Contact } from '../../types/common';

interface ContactEditModalProps {
  open: boolean;
  onSave: (contacts: Contact[]) => void;
  onCancel: () => void;
  contact?: Contact;
  contactTypeOptions: { value: string; label: string }[];
  t: any;
  loading?: boolean;
  disabled?: boolean;
  form?: any;
}

const ContactEditModal: React.FC<ContactEditModalProps> = ({
  open,
  onSave,
  onCancel,
  contact,
  contactTypeOptions,
  t,
  loading = false,
  disabled = false,
  form: externalForm,
}) => {
  const [internalForm] = Form.useForm();
  const form = externalForm || internalForm;

  useEffect(() => {
    if (open) {
      if (contact) {
        form.setFieldsValue({ contacts: [contact] });
      } else {
        form.resetFields();
      }
    }
  }, [open, contact, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      onSave(values.contacts);
    } catch (e) {
      // Form validation failed
    }
  };

  return (
    <Modal
      title={contact ? t('common:editContact', 'Edit Contact') : t('common:addContact', 'Add Contact')}
      open={open}
      onOk={handleOk}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      okText={t('common:save', 'Save')}
      cancelText={t('common:cancel', 'Cancel')}
      confirmLoading={loading}
      okButtonProps={{ disabled }}
      cancelButtonProps={{ disabled }}
      destroyOnHidden
    >
      <Form form={form} layout="vertical" name="contactEditForm">
        <ContactsFormSection t={t} contactTypeOptions={contactTypeOptions} />
      </Form>
    </Modal>
  );
};

export default ContactEditModal; 